import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';

import * as S from './styled';

type SidebarItemProps = {
  label: string;
  icon: ReactNode;
  href: string;
};

export default function SidebarItem({ label, icon, href }: SidebarItemProps) {
  const { pathname } = useLocation();
  const isSelected = href === ROUTE_REDESIGN ? pathname === '/' : pathname.startsWith(href);

  return (
    <Tooltip title={label} placement="right" arrow>
      <S.SidebarItemStyled to={href} isSelected={isSelected} aria-label={label}>
        <div className="sidebar-item-icon">{icon}</div>
      </S.SidebarItemStyled>
    </Tooltip>
  );
}
